exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dayname{font-size:1.5em;text-transform:uppercase}.weathericon{font-size:3em!important}.temp{margin-top:1em;margin-bottom:0;font-size:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c87317e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Weather/WeatherItem.vue
// module id = vrlg
// module chunks = 1